import { useTranslation } from 'react-i18next';
import { NoRowsOverlay } from 'common/components/ConfigurableTable/Components/NoRowsOverlay.tsx';
import { useIsProductsManagementFiltered } from '@/activityLog/productsManagement/Filters/hooks/useIsProductsManagementFiltered.ts';

export const ProductsManagementNoRowsOverlay = () => {
  const { t } = useTranslation();
  const isFiltered = useIsProductsManagementFiltered();

  return (
    <NoRowsOverlay
      message={isFiltered ? t('common.noResults') : t('bulkProvisioning.dragAndDrop')}
    />
  );
};
